import { createComponent } from '@lit/react';
import React from 'react';
import { SDSProcess } from '../sds-process/sds-process';

export const SDSProcessWrapper = createComponent({
	tagName: 'sds-process',
	elementClass: SDSProcess,
	react: React,
	events: {},
});
